export const APP_NAMESPACE = 'FIBER/APP';
export const AVC_NAMESPACE = 'FIBER/AVC';
export const LMS_NAMESPACE = 'FIBER/LMS';
